import axios from 'axios';
import { stringify } from 'query-string';
import Cookies from "js-cookie";

let cookieDomain;
let baseUrl;
let apiUrl;

if(window.location.host.indexOf('localhost') !== -1) {
    cookieDomain = 'localhost';
    baseUrl = 'http://localhost:3000';
    apiUrl = 'http://localhost:80/api';
} else if(window.location.host.indexOf('bravo.msa-reporting.appadministrate.com') !== -1) {
    cookieDomain = 'bravo.msa-reporting.appadministrate.com';
    baseUrl = 'https://bravo.msa-reporting.appadministrate.com';
    apiUrl = 'https://api.bravo.msa-reporting.appadministrate.com';
} else if(window.location.host.indexOf('msa-reporting.appadministrate.com') !== -1) {
    cookieDomain = 'msa-reporting.appadministrate.com';
    baseUrl = 'https://msa-reporting.appadministrate.com';
    apiUrl = 'https://api.msa-reporting.appadministrate.com';
} else {
    cookieDomain = 'mainstreetreporting.org';
    baseUrl = 'https://www.mainstreetreporting.org';
    apiUrl = 'https://api.mainstreetreporting.org';
}

//https://stackoverflow.com/a/52171480
const TSH=s=>{for(var i=0,h=9;i<s.length;)h=Math.imul(h^s.charCodeAt(i++),9**9);return h^h>>>9};

const tokenName = 'msa-token-'+Math.abs(TSH(cookieDomain));

let token = '';
const getAccessToken = () => {
    if(token !== '') {
        return token;
    }

    // let checkToken = localStorage.getItem(tokenName);
    let checkToken = Cookies.get(tokenName);
    if(checkToken/* !== null*/) {
        token = checkToken;
    }

    return token;
}

const unauthenticatedApi = axios.create({
    baseURL: apiUrl,
});

const authenticatedApi = axios.create({
    baseURL: apiUrl,
    headers: {'Authorization': `Bearer ${getAccessToken()}`}
});
// this forces the header to stay up to date when we change the access token in local storage
authenticatedApi.interceptors.request.use((config) => {
    config.headers.Authorization = `Bearer ${getAccessToken()}`;
    return config;
})

const setAccessToken = (accessToken) => {
    if(accessToken === false) {
        // localStorage.removeItem(tokenName);
        Cookies.remove(tokenName, {
            domain: cookieDomain,
        });
        accessToken = '';
    } else {
        // localStorage.setItem(tokenName, accessToken);
        Cookies.set(tokenName, accessToken, {
            domain: cookieDomain,
            expires: 30, // require login every 30 days
        });
    }

    token = accessToken;

    authenticatedApi.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

    return true;
}

/*
const apiClient = axios.create({
    baseURL: apiUrl,
    withCredentials: true,
});
*/

const correctDataBeforeSending = (obj) => {
    for(let prop in obj) {
        // don't send undefined values
        if(typeof obj[prop] === 'undefined') {
            delete obj[prop];
        }

        if (prop === 'created_at' || prop === 'updated_at' || prop === 'deleted_at') {
            delete obj[prop];
        }
        else if (typeof obj[prop] === 'object') {
            correctDataBeforeSending(obj[prop]);
        }
    }
    // todo: recursive
    // delete data.created_at;
    // delete data.updated_at;

    return obj;
}

const dataProvider = {

    request: (resource, params) => {
        return authenticatedApi(`${apiUrl}/${resource}`).then((response) => ({
            data: response.hasOwnProperty('data') ? response.data : response,
        }));
    },

    getList: (resource, params) => {
        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;
        const query = {
            sort: JSON.stringify([field, order]),
            page: page,
            per_page: perPage,
            filter: JSON.stringify(params.filter),
            include: 'default',
            ...params.meta,
        };

        if(params.filter.hasOwnProperty('form_id')) {
            query.filter_mode = 'and';
        }

        const url = `${resource}?${stringify(query)}`;

        return authenticatedApi(url).then(({ data }) => {
            return ({
                data: data.data,
                total: parseInt(data.total),
            })
        });
    },

    getOne: (resource, params) => {
        const query = {
            include: 'all',
            ...params.meta,
        };
        // const query = typeof params.meta === 'object' ? params.meta : {};

        return authenticatedApi(`${apiUrl}/${resource}/${params.id}?${stringify(query)}`).then((response) => ({
            data: response.hasOwnProperty('data') ? response.data : response,
        }));
    },

    getMany: (resource, params) => {
        const query = {
            filter: JSON.stringify({ id: params.ids }),
        };

        const url = `${apiUrl}/${resource}?${stringify(query)}`;
        return authenticatedApi(url).then(({ data }) => ({
            data: data.data,
        }));
    },

    getManyReference: (resource, params) => {
        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;
        const query = {
            sort: JSON.stringify([field, order]),
            // range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
            page: page,
            per_page: perPage,
            filter: JSON.stringify({
                ...params.filter,
                [params.target]: params.id,
            }),
            include: 'default',
        };

        if(params.filter.hasOwnProperty('form_id')) {
            query.filter_mode = 'and';
        }

        const url = `${apiUrl}/${resource}?${stringify(query)}`;

        return authenticatedApi(url).then(({ data }) => ({
            ...data,
        }));
    },

    update: (resource, params) => {

        let data = new FormData();
        for(const key in correctDataBeforeSending(params.data)) {
            if(typeof params.data[key] === 'object') {
                data.append(key, JSON.stringify(params.data[key]));
            } else {
                data.append(key, params.data[key]);
            }
        }

        // return Promise.reject();
        let hasMedia = false;
        if(typeof params.data.media !== 'undefined') {
            for(const media of params.data.media) {
                if(media.hasOwnProperty('rawFile') && media.rawFile instanceof File) {
                    hasMedia = true;
                    data.append('file[]', media.rawFile);
                    console.log('HAS A FILE');
                }
            }
        }

        let updateRequest;
        if(hasMedia) {
            updateRequest = authenticatedApi.post(`${apiUrl}/${resource}/${params.id}`, data);
        } else {
            updateRequest = authenticatedApi.put(`${apiUrl}/${resource}/${params.id}`, correctDataBeforeSending(params.data));
        }

        return updateRequest.then((response) => ({
            data: response.hasOwnProperty('data') ? response.data : response,
        }));
    },

    updateMany: (resource, params) => {
        const query = {
            filter: JSON.stringify({ id: params.ids}),
        };
        return authenticatedApi.put(`${apiUrl}/${resource}?${stringify(query)}`, correctDataBeforeSending(params.data))
        .then(({ data }) => ({
            data: data,
        }));
    },

    create: (resource, params) => {
        let data = new FormData();
        for(const key in correctDataBeforeSending(params.data)) {
            if(typeof params.data[key] === 'object') {
                data.append(key, JSON.stringify(params.data[key]));
            } else {
                data.append(key, params.data[key]);
            }
        }

        // return Promise.reject();
        if(typeof params.data.media !== 'undefined') {
            for(const media of params.data.media) {
                if(media.hasOwnProperty('rawFile') && media.rawFile instanceof File) {
                    data.append('file[]', media.rawFile);
                    console.log('HAS A FILE');
                }
            }
        }

        return authenticatedApi.post(`${apiUrl}/${resource}`, data)
        .then(({ data }) => ({
            data: { ...params.data, id: data.id },
        }));
    },

    delete: (resource, params) => {
        return authenticatedApi(`${apiUrl}/${resource}/${params.id}`, {
            method: 'DELETE',
        }).then(({ data }) => ({
            data: data,
        }));
    },

    deleteMany: (resource, params) => {
        const query = {
            filter: JSON.stringify({ ids: params.ids}),
        };
        // return authenticatedApi(`${apiUrl}/${resource}?${stringify(query)}`, {
        return authenticatedApi(`${apiUrl}/${resource}/${params.ids.join(',')}`, {
            method: 'DELETE',
            // body: JSON.stringify(params.data),
        }).then(({ data }) => ({
            data: data,
        }));
    },
};

export {
    cookieDomain,
    baseUrl,
    apiUrl,
    tokenName,

    getAccessToken,
    setAccessToken,

    unauthenticatedApi,
    authenticatedApi,
};

export default dataProvider;
